import type { Blaze, Blockfrost, WebWallet } from "@blaze-cardano/sdk";
import { Dispatch } from "react";
import { EAppActions, TAppAction } from "./types";

export const AppActions = {
  setBlazeInstance: (
    blaze: Blaze<Blockfrost, WebWallet> | undefined,
    dispatch: Dispatch<TAppAction>,
  ) => {
    dispatch({ type: EAppActions.SET_BLAZE, payload: blaze });
  },

  setProviderInstance: (
    provider: Blockfrost | undefined,
    dispatch: Dispatch<TAppAction>,
  ) => {
    dispatch({ type: EAppActions.SET_PROVIDER, payload: provider });
  },
};
